
import { Component, Prop, Vue } from "vue-property-decorator";
import {IAppTable} from "@/shared/AppTable/interfaces/sort-table-data";
import {ICorp} from "@/modules/Corps/interfaces/corp.interface";

@Component({})
export default class ActionsCell extends Vue {
  @Prop() cell: IAppTable.ITableProp;
  @Prop() entity: ICorp.IEntity;
  @Prop() index: number;
  @Prop() tableList: ICorp.IEntity[];

  async openCorpPopup() {
    await this.$store.dispatch('dialog/openDialog', {
      blockName: 'allPages',
      dialogName: 'corpPopup',
      payload: {
        corpId: this.entity.id,
        corpName: this.entity.name,
        updateTableItem: true,
      },
    });
  }

}
